
































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import status from '@/components/ProfileApartments/computeStatus';

@Component({
  name: 'ApartmentsListTile',
  props: {
    apartmentsTexts: {
      type: Object,
      default: () => {},
    },
    apartmentTitleText: {
      type: String,
      default: '',
    },
    currencyText: {
      type: String,
      default: '',
    },
    actualListApartments: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [status],
})
export default class ApartmentsListTile extends Vue {}
